<template> 
    <v-dialog v-model="show" hide-overlay fullscreen transition="slide-x-reverse-transition">
        <v-card v-if="video" class="player-wrapper">
            <!-- <v-toolbar color="black" tile dark elevation="0">
                <v-toolbar-title style="font-size: 1.1rem">{{video.name}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="show = false">
                    <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
            </v-toolbar> -->
            <v-btn large :x-large="pcOnly" absolute top :left="phoneOnly" :right="pcOnly" icon dark @click="show = false" :style="`${statusBarOverlay ? 'margin-top: 20px!important;' : ''}`">
                <v-icon v-if="phoneOnly" size="22">mdi-arrow-left</v-icon>
                <v-icon v-else size="22">mdi-close</v-icon>
            </v-btn>

            <div v-if="loading" class="d-flex justify-center align-center pa-12">
                <div style="width: 150px">
                    <v-progress-linear color="muted" indeterminate></v-progress-linear>
                </div>
            </div>
            <div class="iframe-wrapper" v-else-if="videoUrl">
                <iframe id="videoIframe" :src="videoUrlComputed" frameborder="0" allowfullscreen allowtransparency allow="autoplay; fullscreen; picture-in-picture; encrypted-media; accelerometer; gyroscope" :style="`${bottomSafeArea ? 'padding-bottom: 28px!important;' : ''}`" />
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import CryptoHelper from '@/helpers/crypto'

import AppAPI from '@/app-api'

export default {
    props: {
        value: {},
        video: {},
    },
    components: {},
    data(){
        return {
            show: false,
            loading: false,
            videoUrl: null,
        }
    },
    computed: {
        videoUrlComputed(){
            if (!this.videoUrl){
                return null;
            }
            const apiToken = window.localStorage.getItem('tK');
            return `${this.videoUrl}&api_token=${apiToken}`;
        },
        statusBarOverlay(){
            return this.platform === 'ios';
        },
        bottomSafeArea(){
            return this.platform === 'ios';
        },
        ...GlobalComputed,
    },
    watch :{
        show(show){
            if (!show){
                this.$emit('input', false); // close
            }
            AppAPI.changeStatusbar(show);
        },
        value(show){
            this.show = show;
            if (show){
                this.loadVideoData();
            }else{
                this.videoUrl = null;
            }
        },
        video(video){
            if (this.video){
                this.loadVideoData();
            }else{
                this.videoUrl = null;
            }
        }
    },
    methods: {
        loadVideoData(){
            if (!this.loading){
                this.loading = true;
                window.axios.get('/video/apps/' + this.video.id).then(response=>{
                    let url = CryptoHelper.decrypt(response.data.u);
                    url = url.replace('&h=1', '');
                    this.videoUrl = url;
                    this.loading = false;
                }).catch(e=>{
                    this.videoUrl = null;
                    this.loading = false;
                    this.showMsg('حدثت مشكلة أثناء جلب الفيديو، حاول مرة أخرى', 'error');
                    console.error(e)
                })
            }
        },
        ...GlobalMethods,
    },
    mounted(){
        if (this.video){
            this.loadVideoData();
        }
    }
}
</script>

<style lang="scss">
    .player-wrapper{
        position: relative;
        background-color: #000!important;

        .theme--dark.v-toolbar.v-sheet{
            background-color: #000!important;
        }
        .iframe-wrapper{
            display: flex;
            overflow: hidden;
            #videoIframe{
                border: none;
                outline: none;
                width: 100vw;
                height: 100vh;
            }
        }
    }

</style>